
import { formatLeadDate } from "@/utils/lead-utils";
import { Lead, Form } from "@/types";

// Check if a lead is new (less than 24 hours old)
export const isNewLead = (lead: Lead): boolean => {
  const leadDate = new Date(lead.createdAt);
  const now = new Date();
  const differenceInHours = (now.getTime() - leadDate.getTime()) / (1000 * 60 * 60);
  return differenceInHours < 24;
};

// Determine lead status based on various factors
export const determineLeadStatus = (lead: Lead, forms: Form[]): 'cold' | 'warm' | 'hot' => {
  // If the lead already has a status, use it
  if (lead.status === 'cold' || lead.status === 'warm' || lead.status === 'hot') {
    return lead.status;
  }
  
  // Map old statuses to new ones
  if (lead.status === 'new' || lead.status === 'contacted') {
    return 'cold';
  } else if (lead.status === 'qualified') {
    return 'warm';
  } else if (lead.status === 'disqualified') {
    return 'hot';
  }

  // Determine status based on investment amount and timeline
  const investmentData = lead.data["investment_amount"] || 
                        lead.data["investmentAmount"] || 
                        lead.data["Investment Amount"] || "";
  
  const timelineData = lead.data["investment_timeline"] || 
                      lead.data["investmentTimeline"] || 
                      lead.data["Investment Timeline"] || "";
  
  // Higher investment amounts suggest higher quality leads
  if (
    typeof investmentData === 'string' && (
      investmentData.includes('$50,000') || 
      investmentData.includes('$100,000') ||
      investmentData.includes('100k') ||
      investmentData.includes('1M')
    )
  ) {
    return 'hot';
  }
  
  // Immediate timeline indicates hot lead
  if (
    typeof timelineData === 'string' && (
      timelineData.includes('immediately') || 
      timelineData.includes('within a week') ||
      timelineData.includes('ASAP') 
    )
  ) {
    return 'hot';
  }
  
  // Moderate investment amounts or timelines indicate warm leads
  if (
    (typeof investmentData === 'string' && investmentData.includes('$25,000')) || 
    (typeof timelineData === 'string' && timelineData.includes('within a month'))
  ) {
    return 'warm';
  }
  
  // Default to cold
  return 'cold';
};
